import { System } from '../../system';

export interface AppState {
  appReleaseVersion: string;
}

export const initialState: AppState = {
  appReleaseVersion: System.appReleaseVersion,
};
